import React, { useEffect, useState } from 'react';
import { interviewApi } from '../../services/api';
import { InterviewReports } from '../../types';
import Card from '../../components/UI/Card';

const InterviewReportsPanel: React.FC = () => {
  const [reports, setReports] = useState<InterviewReports | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    interviewApi.getReports()
      .then((r) => setReports(r.data.reports))
      .catch((err: unknown) => setError(err instanceof Error ? err.message : 'Could not load interview reports.'));
  }, []);

  if (error) return <p className="text-gray-600">{error}</p>;
  if (!reports) return <p className="text-gray-500">Loading interview reports…</p>;

  const buckets: { title: string; rows: { key: string; count: number }[] }[] = [
    { title: 'By day', rows: reports.byDay },
    { title: 'By week (week starting)', rows: reports.byWeek },
    { title: 'By month', rows: reports.byMonth },
    { title: 'By interviewer', rows: reports.byInterviewer },
    { title: 'By technology', rows: reports.byTechnology },
  ];

  return (
    <div>
      <p className="text-gray-600 mb-4">Pending, scheduled, and completed interviews, with volume by day, week, month, interviewer, and technology.</p>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-6">
        <Card className="p-3"><p className="text-xs text-gray-500">Pending</p><p className="text-xl font-semibold">{reports.pendingCount}</p></Card>
        <Card className="p-3"><p className="text-xs text-gray-500">Scheduled</p><p className="text-xl font-semibold">{reports.scheduledCount}</p></Card>
        <Card className="p-3"><p className="text-xs text-gray-500">Completed</p><p className="text-xl font-semibold">{reports.completedCount}</p></Card>
        <Card className="p-3"><p className="text-xs text-gray-500">Cancelled</p><p className="text-xl font-semibold">{reports.cancelledCount}</p></Card>
        <Card className="p-3"><p className="text-xs text-gray-500">Total</p><p className="text-xl font-semibold">{reports.totalCount}</p></Card>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {buckets.map((bucket) => (
          <Card key={bucket.title} className="p-4">
            <h3 className="font-semibold text-gray-900 mb-3">{bucket.title}</h3>
            {bucket.rows.length === 0 ? (
              <p className="text-sm text-gray-500">No data yet.</p>
            ) : (
              <table className="w-full text-sm">
                <tbody>
                  {bucket.rows.map((row) => (
                    <tr key={row.key} className="border-t border-gray-100">
                      <td className="py-1.5 text-gray-700">{row.key}</td>
                      <td className="py-1.5 text-right font-medium">{row.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
};

export default InterviewReportsPanel;
